import React from "react";
import { twMerge } from "tailwind-merge";

function Button({
  children,
  fullWidth,
  type = "button",
  padding = "px-3 py-2",
  danger,
  disabled,
  color,
  className,
  ...rest
}) {
  return (
    <button
      type={type}
      className={twMerge(
        `
                    flex
                    justify-center
                    items-center
                    rounded-md
                    text-sm
                    cursor-pointer
                    font-medium
                    focus-visible:outline
                    focus-visible:outline-2
                    focus-visible:outline-offset-2                
                `,
        className,
        padding,
        disabled && `opacity-50 cursor-not-allowed`,
        fullWidth && "w-full",
        color ? `${color}` : `text-white`,
        danger && "bg-rose-500 hover:bg-rose-600 focus-visible:outline-rose-600",
        !danger &&
        !color &&
        "bg-[var(--color-primary)] hover:bg-[var(--color-secondary)] hover:text-[var(--color-primary)] focus-visible:outline-blue-[var(--color-primary)]"
      )}
      formNoValidate
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
